export interface GetBankAccountTransactionMatchDefinitionListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetBankAccountTransactionMatchDefinitionListPagingAndFilterResponseData
}

export interface GetBankAccountTransactionMatchDefinitionListPagingAndFilterResponseData {
    items: GetBankAccountTransactionMatchDefinitionListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetBankAccountTransactionMatchDefinitionListPagingAndFilterResponseItem {
    bankAccountTransactionMatchDefinitionId: string
    companyId: string
    bankId: string
    transactionId: string
    debtOrReceivable: string
    customFormId: string
    defaultBankAccountId: any
    defaultCaseId: string
    description: string
    isCustomer: boolean
    isSupplier: boolean
    isAgency: boolean
    isCustomActive: boolean
    currencyTypeId: string
    bankName: string
    customFormName: string
    defaultAccount: string
    currencyTypeName: string
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export const initialGetBankAccountTransactionMatchDefinitionListPagingAndFilterResponseData: GetBankAccountTransactionMatchDefinitionListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}